export const STEP_LOADING = 'loading';
export const STEP_REVIEW = 'review';
export const STEP_RESET = 'reset';
